import { Illustration, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function EducateNewWorkerTitle() {
  return (
    <Stack gap={5} alignItems="center">
      <Illustration type="warning" />
      <Title variant="h3" component="h3" sx={{ textAlign: "center" }}>
        Always Cancel Early
      </Title>
    </Stack>
  );
}
